/**
 * API Configuration
 * Merkezi API konfigürasyonu için kullanılır
 */

// Environment variable validation
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error('NEXT_PUBLIC_API_BASE_URL environment variable is required');
}

// WHATWG URL API kullanarak güvenli URL oluşturma
const baseUrlObj = new URL(API_BASE_URL);

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  
  // WebSocket Hub URL
  WEBSOCKET_HUB_URL: new URL('/hubs/auction', baseUrlObj).toString(),
  
  // API Endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/v1/auth/login',
      REGISTER: '/api/v1/auth/register',
      REFRESH: '/api/v1/auth/refresh-token',
      LOGOUT: '/api/v1/auth/logout',
      CHANGE_PASSWORD: '/api/v1/auth/change-password',
      FORGOT_PASSWORD_RESET: '/api/v1/auth/forgot-password/reset',
      ME: '/api/v1/auth/me',
    },
    AUCTION: {
      FAVORITES: '/api/v1/AuctionFavorites',
      FAVORITES_BY_ID: (id: string) => `/api/v1/AuctionFavorites/${id}`,
      USER_FAVORITES: '/api/v1/AuctionFavorites/user/favorites',
    },
    BIDS: {
      MY_BIDS: '/api/v1/Bids/my-bids',
    },
    DEPOSITS: {
      PENDING_AUCTIONS: '/api/v1/Deposits/pending-deposit-auctions',
    },
    USERS: {
      UPDATE_PROFILE: '/api/v1/Users/update-profile',
      GET_USERS_ADMIN: '/api/v1/users/get-users-admin',
    },
    REQUEST_FORMS: {
      CREATE: '/api/v1/RequestForms',
      ADMIN: '/api/v1/RequestForms/admin',
      BY_ID: (id: string) => `/api/v1/RequestForms/${id}`,
      UPDATE_STATUS: (id: string) => `/api/v1/RequestForms/${id}/status`,
    },
    AUCTIONS: {
      ACTIVE: '/api/v1/auctions/active',
      UPCOMING: '/api/v1/auctions/upcoming',
      COMPLETED: '/api/v1/auctions/completed',
      LIST: '/api/v1/auctions',
      BY_SLUG: (slug: string) => `/api/v1/auctions/slug/${slug}`,
      CREATE_AUCTION_ADMIN: '/api/v1/auctions/create-auction-admin',
      UPDATE_AUCTION_ADMIN: (id: string) => `/api/v1/auctions/update-auction-admin/${id}`,
      ACTIVATE: (id: string) => `/api/v1/auctions/activate/${id}`,
      DEACTIVATE: (id: string) => `/api/v1/auctions/deactivate/${id}`,
      REACTIVATE: '/api/v1/auctions/reactivate',
      BY_ID_ADMIN: (id: string) => `/api/v1/auctions/${id}`,
    },
    CITIES: {
      ALL: '/api/v1/cities',
    },
    DISTRICTS: {
      BY_CITY_IDS: '/api/v1/districts',
    },
    SMS_CODE: {
      SEND: '/api/v1/smscode/send',
      VERIFY: '/api/v1/smscode/verify',
    },
    EIDS: {
      REDIRECT: '/api/v1/auth/eids/redirect',
      VERIFY: '/api/v1/auth/eids/verify',
    },
  },
} as const;

/**
 * Full API URL oluşturur
 * @param endpoint - API endpoint
 * @returns Tam API URL
 */
export const getApiUrl = (endpoint: string): string => {
  // WHATWG URL API kullanarak güvenli URL oluşturma
  return new URL(endpoint, API_CONFIG.BASE_URL).toString();
};

/**
 * OpenRouter Configuration
 * NOT: Client-side'da kullanıldığı için NEXT_PUBLIC_ prefix'i gereklidir
 */
const OPENROUTER_API_KEY = process.env.NEXT_PUBLIC_OPENROUTER_API_KEY;

if (!OPENROUTER_API_KEY) {
  console.warn('OPENROUTER_API_KEY environment variable is not set. OpenRouter features will not be available.');
  console.warn('Please add NEXT_PUBLIC_OPENROUTER_API_KEY to your .env.local file.');
}

export const OPENROUTER_CONFIG = {
  API_KEY: OPENROUTER_API_KEY || '',
  BASE_URL: 'https://openrouter.ai/api/v1',
  IS_AVAILABLE: !!OPENROUTER_API_KEY,
  DEFAULT_MODEL: 'nex-agi/deepseek-v3.1-nex-n1:free',
} as const;

/**
 * Environment kontrolü
 */
export const isProduction = process.env.NODE_ENV === 'production';
export const isDevelopment = process.env.NODE_ENV === 'development';
